import { Divider, ListItem } from "@mui/material";
import Styles from "./VideoList.module.css";
import { VideoWrapper } from "./VideoWrapper";
import { getComponentKey } from "../../utils/utils";

export function VideoThemeWrapper({ id, theme_name, theme_number, videos }) {
  return (
    <ListItem className={Styles.list_item}>
      <div className={Styles.list_item_heading}>
        <h6>
          {theme_number}. {theme_name}
        </h6>
        <Divider className={Styles.list_item_divider} />
      </div>
      <div className={Styles.list_item_video_wrapper}>
        {videos.length ? (
          videos.map((video) => {
            const key = getComponentKey();
            return <VideoWrapper {...video} key={key} />;
          })
        ) : (
          <div className={Styles.list_no_video}>
            <p>Видеоматериал не добавлен</p>
          </div>
        )}
      </div>
    </ListItem>
  );
}
